<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card bg-pattern">
          <div class="card-body p-4">
            <div class="text-center w-75 m-auto">
              <a href="/">
                <span
                ><img src="@assets/images/logo-dark.png" alt="" height="70" width="230"
                /></span>
              </a>
              <p class="text-muted mb-4 mt-3"
                >Enter username and password to access admin panel.</p
              >
            </div>

            <b-alert v-model="isAuthError" variant="danger" dismissible>
              {{authError}}
            </b-alert>

            <b-form @submit.prevent="tryToLogIn">
              <b-form-group
                id="input-group-1"
                label="Username"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="username"
                  type="text"
                  required
                  placeholder="Enter username"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  required
                  placeholder="Enter password"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Log In</b-button
                >
              </b-form-group>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="row mt-3">
          <div class="col-12 text-center">
            <p>
              <router-link tag="a" to="/forget-password" class="text-white-50 ml-1">Forgot your password?</router-link>
              </p
            >
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>

<script>
  import Layout from '@layouts/auth'
  import { authMethods } from '@state/helpers'
  import appConfig from '@src/app.config'
  import NProgress from 'nprogress/nprogress'

  /**
   * Login component
   */
  export default {
    page: {
      title: 'Log in',
      meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
    },
    components: { Layout },
    data() {
      return {
        username: '',
        password: '',
        authError: null,
        tryingToLogIn: false,
        isAuthError: false,
      }
    },
    computed: {

    },
    methods : {
      ...authMethods,
      // Try to log the user in with the username
      // and password they provided.

      async tryToLogIn() {
        NProgress.start()
        this.tryingToLogIn = true
        // Reset the authError if it existed.

        try{

          const { status, message } = await this.logIn({username: this.username,password: this.password})

          if(status){
            this.tryingToLogIn = false
            this.isAuthError = false
            // Redirect to the originally requested page, or to the home page
            this.$router.push(this.$route.query.redirectFrom || { name: 'home' })
          }
          else {
            this.tryingToLogIn = false
            this.isAuthError = true
            this.authError = message
          }
        }
        catch (e){
          this.tryingToLogIn = false
          this.authError = e.response? e.message: 'Error while Login!'
          this.isAuthError = true
        }

        NProgress.stop()
      },
    },
  }
</script>
